import React, { useState } from "react";
import Input from "Components/UI/Input";
import { Controller, useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import { Select, TimePicker } from "antd";
import useTimeConverter from "core/Operations/useTimeConverter";
import { workingHoursValidationSchema } from "MainPages/Employee/Data/EmployeeValidation";

const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const payingType = [
  { id: "1", label: "Fullday", value: "1" },
  { id: "2", label: "Halfday", value: "0.5" },
  { id: "3", label: "Off", value: "0" },
];
const dayList = [
  { value: "monday", label: "Monday", defaultValue: "08.15" },
  { value: "tuesday", label: "Tuesday", defaultValue: "08.15" },
  { value: "wednesday", label: "Wednesday", defaultValue: "08.15" },
  { value: "thursday", label: "Thursday", defaultValue: "08.15" },
  { value: "friday", label: "Friday", defaultValue: "07.30" },
  { value: "saturday", label: "Saturday", defaultValue: "03.30" },
  { value: "sunday", label: "Sunday", defaultValue: "00.00" },
];

const WorkingHoursPopup = ({
  show = false,
  handleClose,
  checkTotalWorkingHours,
}) => {
  const { timeStringToFloat, floatToTimeString } = useTimeConverter();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
    control,
  } = useFormContext();

  const [selectedWeek, setSelectedWeek] = useState([
    watch("alternateWorkingHours[0].week1Hours") || "0.0",
    watch("alternateWorkingHours[0].week2Hours") || "0.0",
    watch("alternateWorkingHours[0].week3Hours") || "0.0",
    watch("alternateWorkingHours[0].week4Hours") || "0.0",
    watch("alternateWorkingHours[0].week5Hours") || "0.0",
  ]);
  const defaultWeekHour = (index) => {
    const day = dayList.find(
      (d) => d.value === watch("alternateWorkingHours[0].dayName")
    );
    return day?.defaultValue || "0.0";
  };

  const updateAlternateWorkingHours = (updatedWeek) => {
    const dayName = watch("alternateWorkingHours[0].dayName");
    if (!dayName) return;

    console.log(updatedWeek);

    const updatedAlternate = {
      code: 0,
      companyCode: watch("companyCode"),
      employeeCode: watch("employeeCode"),
      dayName: dayName,
      isAlternate: true,
      // week1Hours: timeStringToFloat({ timeValue: floatToTimeString({ float: updatedWeek[0] }) }),
      // week2Hours: timeStringToFloat({ timeValue: floatToTimeString({ float: updatedWeek[1] }) }),
      // week3Hours: timeStringToFloat({ timeValue: floatToTimeString({ float: updatedWeek[2] }) }),
      // week4Hours: timeStringToFloat({ timeValue: floatToTimeString({ float: updatedWeek[3] }) }),
      // week5Hours: timeStringToFloat({ timeValue: floatToTimeString({ float: updatedWeek[4] }) }),
      week1Hours: Number(updatedWeek[0]),
      week2Hours: Number(updatedWeek[1]),
      week3Hours: Number(updatedWeek[2]),
      week4Hours: Number(updatedWeek[3]),
      week5Hours: Number(updatedWeek[4]),
      isActive: true,
      createUser: watch("createUser"),
      createDate: watch("createDate"),
      modifyUser: watch("modifyUser"),
      modifyDate: watch("modifyDate"),
    };
    console.log(updatedAlternate);
    setValue("alternateWorkingHours", [updatedAlternate]);
  };

  const handleSelectWeek = (id, checked) => {
    const updated = [...selectedWeek];

    updated[id] = checked ? defaultWeekHour(id) : "0.0";
    setSelectedWeek(updated);
    updateAlternateWorkingHours(updated);
  };
  const handleSelectAlternativeDay = (selectedOption) => {
    console.log(selectedOption);
    if (selectedOption === "") {
      setValue("alternateWorkingHours", []);
    } else {
      setValue("alternateWorkingHours", [
        {
          code: 0,
          companyCode: watch("companyCode"),
          employeeCode: watch("employeeCode"),
          dayName: watch(`alternateWorkingHours[0].dayName`),
          isAlternate: true,
          week1Hours: 0.0,
          week2Hours: timeStringToFloat({
            timeValue: floatToTimeString({
              float: watch(watch(`alternateWorkingHours[0].dayName`)),
            }),
          }),
          // week2Hours: floatToTimeString({
          //   float: watch(watch(`alternateWorkingHours[0].dayName`)),
          // }),
          week3Hours: 0.0,
          week4Hours: timeStringToFloat({
            timeValue: floatToTimeString({
              float: watch(watch(`alternateWorkingHours[0].dayName`)),
            }),
          }),
          // week4Hours: floatToTimeString({
          //   float: watch(watch(`alternateWorkingHours[0].dayName`)),
          // }),
          week5Hours: 0.0,
          isActive: true,
          createUser: watch("createUser"),
          createDate: watch("createDate"),
          modifyUser: watch("modifyUser"),
          modifyDate: watch("modifyDate"),
        },
      ]);
    }
  };
  const [workingHoursError, setWorkingHoursError] = useState("");
  const handleSave = async () => {
    const workingHours = await checkTotalWorkingHours();
    // const valid = await trigger();
    if (workingHours.check) {
      handleClose();
      setWorkingHoursError("");
    } else {
      setWorkingHoursError(
        `Total Working Hours not matched. Weekly Working Hours is : ${workingHours.workingHoursPerWeek} & Assigned Working Hours is : ${workingHours.totalWorkingHours}`
      );
    }
    // } else {
    //   console.log("Validation failed. Do not close modal.");
    // }
  };

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered size="lg">
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>Working Hour Details</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        {dayList.map((day) => (
          <div
            className=" row form-row working-hours-row mb-3 p-2"
            key={day.value}
            style={{ display: "flex" }}
          >
            <div className="col-md-6">
              <label className="form-label">{day.label}</label>
              <TimePicker
                value={
                  watch(day?.value) && watch(day?.value) !== 0
                    ? dayjs(
                        floatToTimeString({ float: watch(day.value) }),
                        "HH:mm"
                      )
                    : null
                  // dayjs(
                  //     floatToTimeString({ float: day.defaultValue }),
                  //     "HH:mm"
                  //   )
                }
                placeholder=""
                className={`form-control working-hours-input mb-3`}
                onChange={(time, timeString) => {
                  console.log(timeString);
                  setValue(
                    day.value,
                    timeStringToFloat({ timeValue: timeString })
                  );
                }}
                format="HH:mm"
                variant="borderless"
                allowClear={true}
                //   style={{ width: "110px" }}
                getPopupContainer={(trigger) => trigger.parentNode}
                showNow={false}
              />
            </div>
            <div className="col-md-6">
              <Input
                type="commonSelect"
                label="Paying Type"
                labelClassName="form-label"
                name={`${day.value}WorkingMode`}
                optionData={payingType}
                placeholder="Select Paying Type"
                // value={watch(day.value)}
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue(`${day.value}WorkingMode`, selectedOption);
                }}
                getPopupContainer={(trigger) => trigger.parentNode}
                className={`form-control select ${
                  errors?.[`${day.value}WorkingMode`] ? "is-invalid" : ""
                }`}
                // labelInValue
                defaultValue={watch(`${day.value}WorkingMode`)}
                required={false}
                requiredMessage=""
              />
            </div>
          </div>
        ))}

        <div className="form-row row">
          <div className="col-md-6">
            <div className="form-group mb-3">
              <input
                type="hidden"
                {...register("alternateWorkingHours[0].isAlternate")}
                value={watch("alternateWorkingHours[0].isAlternate") || false}
              />
              <Input
                name={`alternateWorkingHours[0].dayName`}
                type="commonSelect"
                placeholder="Select Status"
                className={`form-control select ${
                  errors?.alternateWorkingHours?.[0]?.dayName
                    ? "is-invalid"
                    : ""
                }`}
                label="Alternative Day"
                labelClassName="form-label"
                optionData={[{ label: "None", value: "" }, ...dayList]}
                required={false}
                requiredMessage=""
                onSelect={(selectedOption) => {
                  handleSelectAlternativeDay(selectedOption);
                }}
                defaultValue={watch(`alternateWorkingHours[0].dayName`)}
                getPopupContainer={(trigger) => trigger.parentNode}
                // allowClear
                // labelInValue
              />
            </div>
          </div>
          {watch("alternateWorkingHours")?.length > 0 &&
            watch("alternateWorkingHours[0].dayName") !== "" &&
            watch(`alternateWorkingHours[0].dayName`) !== undefined && (
              <div className="col-md-6 alternative-week">
                <ul>
                  {watch("alternateWorkingHours")?.length > 0
                    ? Array.from({ length: 5 }).map((week, id) => (
                        <li key={id}>
                          <div
                            className="form-check"
                            style={{ padding: "5px 30px" }}
                          >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`week-${id}`}
                              checked={
                                parseFloat(
                                  watch(
                                    `alternateWorkingHours[0].week${
                                      id + 1
                                    }Hours`
                                  )
                                ) !== 0.0
                              }
                              onChange={(e) =>
                                handleSelectWeek(id, e.target.checked)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`week-${id}`}
                            >
                              Week - {id + 1} :{" "}
                              {floatToTimeString({
                                float: watch(
                                  `alternateWorkingHours[0].week${id + 1}Hours`
                                ),
                              })}
                            </label>
                          </div>
                        </li>
                      ))
                    : selectedWeek.map((week, id) => (
                        <li key={id}>
                          <div
                            className="form-check"
                            style={{ padding: "5px 30px" }}
                          >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`week-${id}`}
                              checked={parseFloat(week) !== 0.0}
                              onChange={(e) =>
                                handleSelectWeek(id, e.target.checked)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`week-${id}`}
                            >
                              Week - {id + 1} :{" "}
                              {floatToTimeString({
                                float: watch(
                                  watch(`alternateWorkingHours[0].dayName`)
                                ),
                              })}
                            </label>
                          </div>
                        </li>
                      ))}
                </ul>

                {/* <li>
                    Week-2 :{" "}
                    {floatToTimeString({
                      float: watch(watch(`alternateWorkingHours[0].dayName`)),
                    })}
                  </li>
                  <li>
                    Week-3 :{" "}
                    {floatToTimeString({
                      float: watch(watch(`alternateWorkingHours[0].dayName`)),
                    })}
                  </li>
                  <li>
                    Week-4 :{" "}
                    {floatToTimeString({
                      float: watch(watch(`alternateWorkingHours[0].dayName`)),
                    })}
                  </li>
                  <li>
                    Week-5 :{" "}
                    {floatToTimeString({
                      float: watch(watch(`alternateWorkingHours[0].dayName`)),
                    })}
                  </li> */}
              </div>
            )}
        </div>
        {workingHoursError && workingHoursError !== "" && (
          <div className="row">
            <div className="alert alert-danger" role="alert">
              {workingHoursError}
            </div>
          </div>
        )}

        <div className="text-end mt-3">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSave}
          >
            Save & Close
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

WorkingHoursPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  checkTotalWorkingHours: PropTypes.func.isRequired,
};

export default WorkingHoursPopup;

// import React, { useState } from "react";
// import Input from "Components/UI/Input";
// import { useFormContext } from "react-hook-form";
// import PropTypes from "prop-types";
// import { Modal } from "react-bootstrap";
// import dayjs from "dayjs";
// import { TimePicker } from "antd";
// import useTimeConverter from "core/Operations/useTimeConverter";

// const payingType = [
//   { id: "1", label: "Fullday", value: "1" },
//   { id: "2", label: "Halfday", value: "0.5" },
//   { id: "3", label: "Off", value: "0" },
// ];

// const dayList = [
//   { value: "monday", label: "Monday", defaultValue: "08.15" },
//   { value: "tuesday", label: "Tuesday", defaultValue: "08.15" },
//   { value: "wednesday", label: "Wednesday", defaultValue: "08.15" },
//   { value: "thursday", label: "Thursday", defaultValue: "08.15" },
//   { value: "friday", label: "Friday", defaultValue: "07.30" },
//   { value: "saturday", label: "Saturday", defaultValue: "03.30" },
//   { value: "sunday", label: "Sunday", defaultValue: "00.00" },
// ];

// const WorkingHoursPopup = ({ show = false, handleClose }) => {
//   const { timeStringToFloat, floatToTimeString } = useTimeConverter();
//   const {
//     register,
//     formState: { errors },
//     watch,
//     setValue,
//   } = useFormContext();

//   const [selectedWeek, setSelectedWeek] = useState([
//     "0.0",
//     "0.0",
//     "0.0",
//     "0.0",
//     "0.0",
//   ]);

//   const defaultWeekHour = (index) => {
//     const day = dayList.find(
//       (d) => d.value === watch("alternateWorkingHours[0].dayName")
//     );
//     return day?.defaultValue || "0.0";
//   };

//   const updateAlternateWorkingHours = (updatedWeek) => {
//     const dayName = watch("alternateWorkingHours[0].dayName");
//     if (!dayName) return;

//     console.log(updatedWeek);

//     const updatedAlternate = {
//       code: 0,
//       companyCode: watch("companyCode"),
//       employeeCode: watch("employeeCode"),
//       dayName: dayName,
//       isAlternate: true,
//       // week1Hours: timeStringToFloat({ timeValue: floatToTimeString({ float: updatedWeek[0] }) }),
//       // week2Hours: timeStringToFloat({ timeValue: floatToTimeString({ float: updatedWeek[1] }) }),
//       // week3Hours: timeStringToFloat({ timeValue: floatToTimeString({ float: updatedWeek[2] }) }),
//       // week4Hours: timeStringToFloat({ timeValue: floatToTimeString({ float: updatedWeek[3] }) }),
//       // week5Hours: timeStringToFloat({ timeValue: floatToTimeString({ float: updatedWeek[4] }) }),
//       week1Hours: Number(updatedWeek[0]),
//       week2Hours: updatedWeek[1],
//       week3Hours: updatedWeek[2],
//       week4Hours: updatedWeek[3],
//       week5Hours: updatedWeek[4],
//       isActive: true,
//       createUser: watch("createUser"),
//       createDate: watch("createDate"),
//       modifyUser: watch("modifyUser"),
//       modifyDate: watch("modifyDate"),
//     };
//     console.log(updatedAlternate);
//     setValue("alternateWorkingHours", [updatedAlternate]);
//   };

//   const handleSelectWeek = (id, checked) => {
//     const updated = [...selectedWeek];
//     updated[id] = checked ? defaultWeekHour(id) : "0.0";
//     setSelectedWeek(updated);
//     updateAlternateWorkingHours(updated);
//   };

//   const handleSelectAlternativeDay = (selectedOption) => {
//     if (selectedOption === "") {
//       setValue("alternateWorkingHours", []);
//       setSelectedWeek(["0.0", "0.0", "0.0", "0.0", "0.0"]);
//     } else {
//       setValue("alternateWorkingHours", [
//         {
//           code: 0,
//           companyCode: watch("companyCode"),
//           employeeCode: watch("employeeCode"),
//           dayName: selectedOption,
//           isAlternate: true,
//           week1Hours: 0.0,
//           week2Hours: 0.0,
//           week3Hours: 0.0,
//           week4Hours: 0.0,
//           week5Hours: 0.0,
//           isActive: true,
//           createUser: watch("createUser"),
//           createDate: watch("createDate"),
//           modifyUser: watch("modifyUser"),
//           modifyDate: watch("modifyDate"),
//         },
//       ]);
//     }
//   };

//   const handleSave = () => {
//     handleClose();
//   };

//   return (
//     <Modal show={show} onHide={handleClose} animation={true} centered size="lg">
//       <Modal.Header
//         className="modal-header border-0 custom-modal-header"
//         style={{ justifyContent: "space-between" }}
//       >
//         <div className="page-title">
//           <h4>Working Hour Details</h4>
//         </div>
//         <button type="button" className="close" onClick={handleClose}>
//           <span aria-hidden="true">×</span>
//         </button>
//       </Modal.Header>
//       <Modal.Body>
//         {dayList.map((day) => (
//           <div
//             className="row form-row working-hours-row mb-3 p-2"
//             key={day.value}
//           >
//             <div className="col-md-6">
//               <label className="form-label">{day.label}</label>
//               <TimePicker
//                 value={
//                   watch(day.value) && watch(day.value) !== 0
//                     ? dayjs(
//                         floatToTimeString({ float: watch(day.value) }),
//                         "HH:mm"
//                       )
//                     : null
//                 }
//                 className="form-control working-hours-input mb-3"
//                 onChange={(time, timeString) =>
//                   setValue(
//                     day.value,
//                     timeStringToFloat({ timeValue: timeString })
//                   )
//                 }
//                 format="HH:mm"
//                 variant="borderless"
//                 allowClear={true}
//                 getPopupContainer={(trigger) => trigger.parentNode}
//                 showNow={false}
//               />
//             </div>
//             <div className="col-md-6">
//               <Input
//                 type="commonSelect"
//                 label="Paying Type"
//                 name={`${day.value}WorkingMode`}
//                 optionData={payingType}
//                 onChange={(selectedOption) => {
//                   setValue(`${day.value}WorkingMode`, selectedOption);
//                 }}
//                 getPopupContainer={(trigger) => trigger.parentNode}
//                 className={`form-control select ${
//                   errors?.[`${day.value}WorkingMode`] ? "is-invalid" : ""
//                 }`}
//                 defaultValue={watch(`${day.value}WorkingMode`)}
//                 required={false}
//               />
//             </div>
//           </div>
//         ))}

//         <div className="form-row row">
//           <div className="col-md-6">
//             <div className="form-group mb-3">
//               <input
//                 type="hidden"
//                 {...register("alternateWorkingHours[0].isAlternate")}
//                 value={watch("alternateWorkingHours[0].isAlternate") || false}
//               />
//               <Input
//                 name={`alternateWorkingHours[0].dayName`}
//                 type="commonSelect"
//                 placeholder="Select Status"
//                 className={`form-control select ${
//                   errors?.alternateWorkingHours?.[0]?.dayName
//                     ? "is-invalid"
//                     : ""
//                 }`}
//                 label="Alternative Day"
//                 labelClassName="form-label"
//                 optionData={[{ label: "None", value: "" }, ...dayList]}
//                 required={false}
//                 onSelect={(selectedOption) => {
//                   handleSelectAlternativeDay(selectedOption);
//                 }}
//                 defaultValue={watch(`alternateWorkingHours[0].dayName`)}
//                 getPopupContainer={(trigger) => trigger.parentNode}
//               />
//             </div>
//           </div>

//           {watch("alternateWorkingHours")?.length > 0 &&
//             watch("alternateWorkingHours[0].dayName") !== "" && (
//               <div className="col-md-6 alternative-week">
//                 <ul>
//                   {selectedWeek.map((week, id) => (
//                     <li key={id}>
//                       <div
//                         className="form-check"
//                         style={{ padding: "5px 30px" }}
//                       >
//                         <input
//                           className="form-check-input"
//                           type="checkbox"
//                           id={`week-${id}`}
//                           checked={parseFloat(week) !== 0.0}
//                           onChange={(e) =>
//                             handleSelectWeek(id, e.target.checked)
//                           }
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor={`week-${id}`}
//                         >
//                           Week - {id + 1} : {floatToTimeString({ float: week })}
//                         </label>
//                       </div>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}
//         </div>

//         <div className="text-end mt-3">
//           <button
//             type="button"
//             className="btn btn-primary"
//             onClick={handleSave}
//           >
//             Save & Close
//           </button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// WorkingHoursPopup.propTypes = {
//   show: PropTypes.bool.isRequired,
//   handleClose: PropTypes.func.isRequired,
// };

// export default WorkingHoursPopup;
